import type { UpdateStatus } from "@/shared/types/update";

// Используем глобальные типы из electronIPC.ts
type ElectronAPI = Window["electronAPI"];

export class UpdateIPCService {
  /**
   * Проверка наличия обновлений через Electron IPC
   */
  static async checkForUpdates(): Promise<{
    updateAvailable: boolean;
    version?: string;
    releaseNotes?: string;
  }> {
    const api = window.electronAPI as ElectronAPI | undefined;
    if (!api) {
      throw new Error("Electron API not available");
    }
    return api.checkForUpdates();
  }

  /**
   * Запуск процесса обновления
   */
  static async startUpdate(): Promise<void> {
    const api = window.electronAPI as ElectronAPI | undefined;
    if (!api) {
      throw new Error("Electron API not available");
    }
    return api.startUpdate();
  }

  /**
   * Получение текущего статуса обновления
   */
  static async getUpdateStatus(): Promise<UpdateStatus> {
    const api = window.electronAPI as ElectronAPI | undefined;
    if (!api) {
      return { status: "idle" };
    }
    return api.getUpdateStatus();
  }

  /**
   * Подписка на изменения статуса обновления
   */
  static onUpdateStatusChange(
    callback: (status: UpdateStatus) => void
  ): () => void {
    const api = window.electronAPI as ElectronAPI | undefined;
    if (!api) {
      return () => {};
    }
    return api.onUpdateStatusChange(callback);
  }

  /**
   * Проверка доступности Electron API
   */
  static isAvailable(): boolean {
    return typeof window !== "undefined" && !!(window.electronAPI as ElectronAPI | undefined);
  }
}
